import { Button } from "@icg360/design-system";

import styles from "./footer-banner.module.scss";

type FooterBannerProps = {
  bannerText: string;
  bannerButtonText: string;
  bannerLink: string;
  eventName?: string;
};

export const FooterBanner = ({
  bannerText,
  bannerButtonText,
  bannerLink,
}: FooterBannerProps) => {
  return (
    <div className={styles.bannerSpacer}>
      <div className={styles.banner}>
        {bannerText}
        <a href={bannerLink}>
          <Button appearance="secondary" data-testid="footer-banner-btn">
            {bannerButtonText}
          </Button>
        </a>
      </div>
    </div>
  );
};
